import { useCallback, type MouseEvent } from 'react';
import type { AnimationDirection } from '../utils/carouselUtils';

interface UseCarouselNavigationProps {
  currentChunkIndex: number;
  isAnimating: boolean;
  isFirstChunk: boolean;
  isLastChunk: boolean;
  animateAndChangeChunk: (direction: AnimationDirection, newChunkIndex: number) => void;
}

export const useCarouselNavigation = ({
  currentChunkIndex,
  isAnimating,
  isFirstChunk,
  isLastChunk,
  animateAndChangeChunk,
}: UseCarouselNavigationProps) => {
  const moveItemsLeft = useCallback((event: MouseEvent) => {
    event.preventDefault();
    if (isFirstChunk || isAnimating) {
      return;
    }
    animateAndChangeChunk('right', currentChunkIndex - 1);
  }, [isFirstChunk, isAnimating, animateAndChangeChunk, currentChunkIndex]);

  const moveItemsRight = useCallback((event: MouseEvent) => {
    event.preventDefault();
    if (isLastChunk || isAnimating) {
      return;
    }
    animateAndChangeChunk('left', currentChunkIndex + 1);
  }, [isLastChunk, isAnimating, animateAndChangeChunk, currentChunkIndex]);

  const moveToChunk = useCallback((event: MouseEvent, chunkIndex: number) => {
    event.preventDefault();
    const direction: AnimationDirection = chunkIndex > currentChunkIndex ? 'left' : 'right';
    animateAndChangeChunk(direction, chunkIndex);
  }, [currentChunkIndex, animateAndChangeChunk]);

  return {
    moveItemsLeft,
    moveItemsRight,
    moveToChunk,
  };
};
